import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./translations/locales/en/translation.json";
import translationES from "./translations/locales/es/translation.json";
import translationJA from "./translations/locales/ja/translation.json";
import translationFR from "./translations/locales/fr/translation.json";

let lang = "en";
if (window.location.pathname.match("/es/")) {
  localStorage.setItem("i18nextLng", "es");
  lang = "es";
} else if (window.location.pathname.match("/ja/")) {
  localStorage.setItem("i18nextLng", "ja");
  lang = "ja";
} else if (window.location.pathname.match("/fr/")) {
  localStorage.setItem("i18nextLng", "fr");
  lang = "fr";
} else if (window.location.pathname.match("/it/")) {
  localStorage.setItem("i18nextLng", "it");
  lang = "it";
} else {
  localStorage.setItem("i18nextLng", "en");
}

export const fallbackLng = [lang];
export const availableLanguages = [
  "en",
  "es",
  "fr",
  "pt",
  "ar",
  "it",
  "pl",
  "ru",
  "de",
  "vi",
  "zh",
  "ph",
  "ja",
  "nl",
  "hi",
  "tr",
  "tl",
];

const resources = {
  en: {
    translation: (() => {
      return translationEN;
    })(),
  },
  es: {
    translation: (() => {
      return translationES;
    })(),
  },
  ja: {
    translation: (() => {
      return translationJA;
    })(),
  },
  fr: {
    translation: (() => {
      return translationFR;
    })(),
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    detection: {
      checkWhitelist: true,
    },

    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
